import { memo } from "react";

const DefaultTableCell = ({ value }: { value: string }) => {
  return <div>{value || "--"}</div>;
};

export default memo(DefaultTableCell);
